/* ============ Watch: click-to-load YouTube facade ============ */
(function () {
  var wrap = $('#watch-player');
  if (!wrap) return;

  var playlist = wrap.dataset.playlist || '';
  var defaultVideo = (wrap.dataset.defaultVideo || '').trim();

  function playVideo(id) {
    var src = id
      ? 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1'
      : 'https://www.youtube-nocookie.com/embed/videoseries?list=' + encodeURIComponent(playlist) + '&autoplay=1&rel=0&modestbranding=1';
    wrap.innerHTML = '<iframe src="' + src + '" title="Cassia Optimal Health on YouTube" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
  }

  wrap.addEventListener('click', function (e) {
    /* A manually featured video (featured_video_id) always wins; with none set,
       this plays the channel's uploads playlist, which opens on the latest upload. */
    if (e.target.closest('[data-play]')) playVideo(defaultVideo || null);
  });

  var clips = $('#watch-clips');
  if (clips && clips.dataset.featured) {
    var ids = clips.dataset.featured
      .split(',')
      .map(function (s) { return s.trim().replace(/[^a-zA-Z0-9_-]/g, ''); })
      .filter(Boolean)
      .slice(0, 3);

    clips.innerHTML = ids.map(function (id) {
      return '<button class="clip" type="button" data-video="' + id + '" aria-label="' + 'Play video' + '">' +
        '<span class="thumb"><img src="https://i.ytimg.com/vi/' + id + '/hqdefault.jpg" alt="" loading="lazy"></span>' +
        '</button>';
    }).join('');

    clips.addEventListener('click', function (e) {
      var c = e.target.closest('[data-video]');
      if (!c) return;
      playVideo(c.dataset.video);
      wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }
})();
